import {
  createSlice,
  createAsyncThunk,
  createSelector } from
"@reduxjs/toolkit";
import { ApolloClient, gql, NormalizedCacheObject } from "@apollo/client";
import { RootState } from "@src/redux/store";
import * as TYPES from "@src/redux/types";

const GRAPHQL = gql`
  query getAdditionalReportSignedUrl($data: reportSignedUrlInput!) {
    getAdditionalReportSignedUrl(data: $data) {
      url
      filename
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.SignedUrlState = {
  result: null,
  error: null,
  loading: false
};

export const getAdditionalReportSignedUrlRequest = createAsyncThunk<
  TYPES.SignedUrl,
  {data: TYPES.ReportSignedUrlInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  "additional_report/get_additional_report_signed_url",
  async (params: {data: TYPES.ReportSignedUrlInput;}, { extra: client }) => {
    try {
      const response = await client.query({
        query: GRAPHQL,
        variables: params
      });
      return response.data.getAdditionalReportSignedUrl;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || "An error occurred",
        statusCode: err.statusCode || "500"
      });
    }
  }
);

const getAdditionalReportSignedUrlSlice = createSlice({
  name: "get_additional_report_signed_url",
  initialState: initialState,
  reducers: {
    getAdditionalReportSignedUrlClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getAdditionalReportSignedUrlRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      getAdditionalReportSignedUrlRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      getAdditionalReportSignedUrlRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: "Failed to fetch",
          statusCode: "500"
        };
        state.loading = false;
      }
    );
  }
});

export const { getAdditionalReportSignedUrlClear } =
getAdditionalReportSignedUrlSlice.actions;

export const getAdditionalReportSignedUrl = createSelector(
  (state: RootState) =>
  state.additionalReport.getAdditionalReportSignedUrl.result,
  (state: RootState) =>
  state.additionalReport.getAdditionalReportSignedUrl.error,
  (state: RootState) =>
  state.additionalReport.getAdditionalReportSignedUrl.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getAdditionalReportSignedUrlSlice.reducer;